/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';

/**
 * 
 * @export
 * @interface GetParamsDto
 */
export interface GetParamsDto {
    /**
     * 
     * @type {string}
     * @memberof GetParamsDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetParamsDto
     */
    group: GetParamsDtoGroupEnum;
    /**
     * 
     * @type {string}
     * @memberof GetParamsDto
     */
    name: GetParamsDtoNameEnum;
    /**
     * 
     * @type {string}
     * @memberof GetParamsDto
     */
    type: GetParamsDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetParamsDto
     */
    valueString?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetParamsDto
     */
    valueBoolean?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetParamsDto
     */
    valueDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof GetParamsDto
     */
    valueNumber?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetParamsDto
     */
    isEditable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetParamsDto
     */
    isVisible: boolean;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetParamsDto
     */
    owner?: GetEmployeeDto;
    /**
     * 
     * @type {Date}
     * @memberof GetParamsDto
     */
    ts?: Date;
}


/**
 * @export
 */
export const GetParamsDtoGroupEnum = {
    Eod: 'EOD',
    Fvz: 'FVZ',
    Ump: 'UMP',
    Sys: 'SYS',
    Surowka: 'Surowka',
    Api: 'API',
    MirrorProject: 'MirrorProject'
} as const;
export type GetParamsDtoGroupEnum = typeof GetParamsDtoGroupEnum[keyof typeof GetParamsDtoGroupEnum];

/**
 * @export
 */
export const GetParamsDtoNameEnum = {
    LastProcessedDocumentsDate: 'LastProcessedDocumentsDate',
    LastProcessedClientsDate: 'LastProcessedClientsDate',
    TurnOffPurchaseInvoiceDomestic: 'TurnOffPurchaseInvoiceDomestic',
    DaysToCancelFvzNumber: 'DaysToCancelFVZNumber',
    UmpRequestUserForDebug: 'UMPRequestUserForDebug',
    UmpLogs: 'UMPLogs',
    NewPositionApplicationUrl: 'NewPositionApplicationUrl',
    SurowkaFromYear: 'SurowkaFromYear',
    SurowkaBaseName: 'SurowkaBaseName',
    SurowkaBackupSubfolder: 'SurowkaBackupSubfolder',
    MirrorProjectResponsibleUser: 'MirrorProjectResponsibleUser',
    ContractsForWorkUrl: 'ContractsForWorkUrl',
    SurveyEmailMessagePl: 'SurveyEmailMessagePl',
    SurveyEmailMessageEng: 'SurveyEmailMessageEng',
    MediaplannerApiProjectsByTeamsForCompanies: 'MediaplannerApiProjectsByTeamsForCompanies',
    MirrorProjectProfileName: 'MirrorProjectProfileName',
    MirrorProjectCompanySysNumber: 'MirrorProjectCompanySysNumber',
    MirrorProjectTeamSysNumber: 'MirrorProjectTeamSysNumber'
} as const;
export type GetParamsDtoNameEnum = typeof GetParamsDtoNameEnum[keyof typeof GetParamsDtoNameEnum];

/**
 * @export
 */
export const GetParamsDtoTypeEnum = {
    String: 'String',
    Boolean: 'Boolean',
    Number: 'Number',
    Date: 'Date'
} as const;
export type GetParamsDtoTypeEnum = typeof GetParamsDtoTypeEnum[keyof typeof GetParamsDtoTypeEnum];


/**
 * Check if a given object implements the GetParamsDto interface.
 */
export function instanceOfGetParamsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "group" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "isEditable" in value;
    isInstance = isInstance && "isVisible" in value;

    return isInstance;
}

export function GetParamsDtoFromJSON(json: any): GetParamsDto {
    return GetParamsDtoFromJSONTyped(json, false);
}

export function GetParamsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetParamsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'group': json['group'],
        'name': json['name'],
        'type': json['type'],
        'valueString': !exists(json, 'valueString') ? undefined : json['valueString'],
        'valueBoolean': !exists(json, 'valueBoolean') ? undefined : json['valueBoolean'],
        'valueDate': !exists(json, 'valueDate') ? undefined : (new Date(json['valueDate'])),
        'valueNumber': !exists(json, 'valueNumber') ? undefined : json['valueNumber'],
        'isEditable': json['isEditable'],
        'isVisible': json['isVisible'],
        'owner': !exists(json, 'owner') ? undefined : GetEmployeeDtoFromJSON(json['owner']),
        'ts': !exists(json, 'ts') ? undefined : (new Date(json['ts'])),
    };
}

export function GetParamsDtoToJSON(value?: GetParamsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'group': value.group,
        'name': value.name,
        'type': value.type,
        'valueString': value.valueString,
        'valueBoolean': value.valueBoolean,
        'valueDate': value.valueDate === undefined ? undefined : (value.valueDate.toISOString()),
        'valueNumber': value.valueNumber,
        'isEditable': value.isEditable,
        'isVisible': value.isVisible,
        'owner': GetEmployeeDtoToJSON(value.owner),
        'ts': value.ts === undefined ? undefined : (value.ts.toISOString()),
    };
}

